module.exports = __webpack_public_path__ + "img/zoe_estates_handover_keys_003.45b47d8a.jpg";